import React, { Component } from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { Modal } from 'react-bootstrap';
import { SubmissionError } from 'redux-form/immutable';
import ChangePasswordForm from 'components/ChangePasswordForm';
import NotificationWindow from 'components/NotificationWindow';
import TextButton from 'components/TextButton';
import { ERROR_SERVER_ERROR, PASSWORD_SUCCESS_MESSAGE } from 'utils/messages';
import CloseIcon from 'resources/Icon-Close-Btn.svg';
import './ChangePasswordModal.css';

class ChangePasswordModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successful: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  handleSubmit(values) {
    const input = values.toJS();

    return this.props
      .changePassword(input.oldPassword, input.password)
      .then(resp => {
        const result = resp && resp.data && resp.data.changePassword;
        if (result && result.success) {
          this.setState({ successful: true });
        } else {
          const error = (result && result.message) || ERROR_SERVER_ERROR;
          throw new SubmissionError({ _error: error });
        }
        return resp;
      })
      .catch(error => {
        if (error instanceof SubmissionError) {
          throw error;
        } else {
          if (error.message) {
            console.error(error.message);
          } else {
            console.error(JSON.stringify(error));
          }
          throw new SubmissionError({ _error: ERROR_SERVER_ERROR });
        }
      });
  }

  onClose() {
    this.props.closePasswordModal();
    this.setState({
      successful: false
    });
  }

  render() {
    let content;
    if (this.state.successful) {
      content = (
        <NotificationWindow
          message={PASSWORD_SUCCESS_MESSAGE}
          closeUrl="/profile"
          variant={'success'}
        />
      );
    } else {
      content = (
        <ChangePasswordForm
          resetPassword={false}
          onSubmit={this.handleSubmit}
        />
      );
    }

    return (
      <Modal
        show={this.props.showEditPassword}
        className="change-password-modal"
        backdrop="static"
      >
        <Modal.Body>{content}</Modal.Body>
        <TextButton
          onClick={this.onClose}
          className="close-modal-button"
          type="button"
        >
          <img src={CloseIcon} alt="Close Dialog" />
        </TextButton>
      </Modal>
    );
  }
}

const CHANGE_PASSWORD_MUTATION = gql`
  mutation MyChangePassword($userChangePassword: UserChangePassword!) {
    changePassword(userChangePassword: $userChangePassword) {
      success
      message
    }
  }
`;

const withData = graphql(CHANGE_PASSWORD_MUTATION, {
  props: ({ ownProps, mutate }) => ({
    changePassword: (oldPassword, newPassword) =>
      mutate({
        variables: { userChangePassword: { oldPassword, newPassword } }
      })
  })
});

export default withData(ChangePasswordModal);
